export default defineNuxtPlugin(() => {
    const router = useRouter();
    const { capture } = useLeadTracking();
    capture();
    router.afterEach(() => { capture(); });
})